import GxIconButton from "@/app/components/common/actions/buttons/GxIconButton";
import GxDropdownSmall from "@/app/components/common/actions/dropdowns/GxDropdownSmall";
import InfoTooltip from "@/app/components/common/badge/InfoTooltip";
import { t } from "i18next";

export interface AuthGroupItem {
  level: number;
  groupId: number | null;
}

interface DropdownOption {
  authGroupId: number;
  groupCode: string;
  // Optional so this stays backward compatible with any caller that hasn't
  // been updated yet to pass groupName through in its options list.
  groupName?: string;
}

interface AuthGroupSelectorProps {
  item: AuthGroupItem;
  dropdownData: DropdownOption[];
  onGroupChange: (value: DropdownOption | null) => void;
  onDelete?: () => void;
  tooltip?: string;
  canDelete?: boolean;
  required?: boolean;
}

const AuthGroupSelector = ({
  item,
  dropdownData,
  onGroupChange,
  onDelete,
  tooltip,
  canDelete = true,
  required = true,
}: AuthGroupSelectorProps) => {
  console.log(item);

  const selectedItem =
    dropdownData.find((option) => option.authGroupId === item.groupId) || null;

  // Display label for the currently selected group in the tooltip subtitle.
  // Falls back to groupCode if groupName isn't available on this option yet.
  const selectedGroupLabel = selectedItem?.groupName || selectedItem?.groupCode;

  // FIX: GxDropdownSmall's onChange calls back with the raw field value it was
  // configured with (here `opt[option]` i.e. opt.groupCode), NOT the full
  // { authGroupId, groupCode } option object. onGroupChange (and the parent's
  // handleGroupChange) expects the full object so it can resolve authGroupId,
  // so we resolve the raw groupCode back to its matching option here before
  // calling onGroupChange. Without this, authGroupId was always undefined and
  // the selection never made it into the payload.
  const handleDropdownChange = (selectedGroupCode: string | number) => {
    const matched =
      dropdownData.find((option) => option.groupCode === selectedGroupCode) ||
      null;
    onGroupChange(matched);
  };
  

  return (
    <div className="gx-authgrp-container">
      <p className="gx-p14-sb">{item.level}</p>

      <div className="w-[10vw]">
        <GxDropdownSmall
          data={dropdownData}
          // Show the group's display name in the options list instead of its
          // code. The value/selection matching still keys off groupCode
          // (handleDropdownChange resolves back to the full option by code),
          // so only the visible `name` field changes here.
          name="groupName"
          option="groupCode"
          value={selectedItem?.groupCode}
          keyName="groupCode"
          onChange={handleDropdownChange}
          placeholder={t("Auth Group")}
          required={required}
        />
      </div>

      <div className="gx-authgrp-action-btn">
        {tooltip && (
          <InfoTooltip
            variant="callout"
            tooltip="Required Approvals 1"
            subtitle={`Level ${item.level} any 1 user can approve from the Group ${
              selectedGroupLabel || ""
            }`}
            direction="left"
            maxWidth={250}
            
          />
        )}

        <GxIconButton
          type="delete"
          disabled={!canDelete}
          alt="Delete Icon"
          onClick={onDelete}
        />
      </div>
    </div>
  );
};

export default AuthGroupSelector;
